import { IStyle, ITheme, memoizeFunction } from "@fluentui/react";

export const SIDEPANE_ITEM_PADDING_VERTICAL = '1.25rem';  //20px
export const SIDEPANE_ITEM_PADDING_HORIZONTAL = '1rem';       //16px
export const SIDEPANE_ITEM_PADDING_VERTICAL_SMALL = '0.625rem';       //10px

export const sidePanePadding = `${SIDEPANE_ITEM_PADDING_VERTICAL} ${SIDEPANE_ITEM_PADDING_HORIZONTAL}`; //== '16px 20px'
export const sidePanePaddingSmall = `${SIDEPANE_ITEM_PADDING_VERTICAL_SMALL} ${SIDEPANE_ITEM_PADDING_HORIZONTAL}`; //== '10px 20px'
export const sidePanePaddingNegative = `0 -${SIDEPANE_ITEM_PADDING_HORIZONTAL} 0 -${SIDEPANE_ITEM_PADDING_HORIZONTAL}`;

/** Styles theme for components under SidePanel. It should be common for mobile and desktop. */
export const sidepaneItemStyle = (theme: ITheme, isMobile: boolean): IStyle => ({
    overflowY: 'hidden',  //makes a child element to be able to show scrollbar
    flexGrow: 1,    //makes space evenly distributed between siblings
    flexBasis: "50%", //makes space evenly distributed between siblings (via "flex-shrink: 1" as a default value)
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.semanticColors.cardStandoutBackground,
    padding: 0,
    fontSize: '0.875rem', //== 14px == theme.fonts.medium
    borderRadius: isMobile ? '0' : '6px', //6px == theme.effects.roundedCorner6
});

export const sidepaneItemHeaderStyles = memoizeFunction((isShortScreen: boolean) => ({
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '1rem', //== 16px == theme.fonts.mediumPlus

    background: '#F9FAFB',
    position: 'relative', //makes the 'box-shadow' css rule work
    boxShadow: '0px 2px 10px 0px #00000026',
    padding: isShortScreen ? sidePanePaddingSmall : sidePanePadding,
} as IStyle));

export const sidePaneContentWrapperStyles = (theme: ITheme) => ({
    paddingTop: SIDEPANE_ITEM_PADDING_VERTICAL_SMALL,
    //paddingRight: 0,    //move inner vertical scrollbar to the most right position (it is 0 by default)
    overflow: 'hidden',
    flexGrow: 1,    //makes space evenly distributed between siblings
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.white,    //'#F0F2F4',
} as IStyle);


export const getSidepaneIconActionStyles = (theme: ITheme): IStyle => ({
    fontSize: '1.375rem',
    cursor: 'pointer',
    "&:hover": {
        color: theme.palette.accent
    },
});
